import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, Users, Menu, X } from 'lucide-react';

const Header: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (!isHomePage) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  // Fechar menu mobile quando a rota mudar
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  // Determina as classes do header baseado na página e scroll
  const getHeaderClasses = () => {
    if (isHomePage) {
      return isScrolled 
        ? 'bg-gray-800 shadow-md' 
        : 'bg-transparent';
    }
    return 'bg-gray-800 shadow-md';
  };

  // Determina as classes do texto baseado na página e scroll
  const getTextClasses = (isActiveLink = false) => {
    const baseClasses = 'relative flex items-center justify-start space-x-1 px-3 py-2 transition-all duration-300 group text-left';
    
    if (isHomePage && !isScrolled) {
      return `${baseClasses} text-white hover:text-white ${isActiveLink ? 'font-medium' : ''}`;
    }
    
    return `${baseClasses} text-white hover:text-gray-200 ${isActiveLink ? 'font-medium' : ''}`;
  };


  // Determina as classes do botão mobile baseado na página e scroll
  // Determina as classes do botão mobile baseado na página e scroll
  const getMobileButtonClasses = () => {
    if (isHomePage && !isScrolled) {
      return 'text-white hover:text-white';
    }
    return 'text-white hover:text-gray-200';
  };

  return (
    <header className={`sticky top-0 z-40 transition-all duration-300 ${getHeaderClasses()}`}>
      <div className="container mx-auto px-4 py-4 max-w-[80vw]">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/lovable-uploads/b45dae5a-5dfa-45a0-bc80-52e7a950e93e.png" 
              alt="Fox Vendas"
              className="h-12 w-auto"
            />
          </Link>

          <nav className="hidden md:flex items-center space-x-6">
            <Link 
              to="/" 
              className={getTextClasses(isActive('/'))}
            >
              <Home className="w-4 h-4" />
              <span>Início</span>
              <span className={`absolute bottom-0 left-0 h-0.5 bg-white transition-all duration-300 ${
                isActive('/') 
                  ? 'w-full' 
                  : 'w-0 group-hover:w-full'
              }`}></span>
            </Link>
            <Link 
              to="/busca" 
              className={getTextClasses(isActive('/busca'))}
            >
              <Search className="w-4 h-4" />
              <span>Buscar</span>
              <span className={`absolute bottom-0 left-0 h-0.5 bg-white transition-all duration-300 ${
                isActive('/busca') 
                  ? 'w-full' 
                  : 'w-0 group-hover:w-full'
              }`}></span>
            </Link>
            <Link 
              to="/quem-somos" 
              className={getTextClasses(isActive('/quem-somos'))}
            >
              <Users className="w-4 h-4" />
              <span>Quem Somos</span>
              <span className={`absolute bottom-0 left-0 h-0.5 bg-white transition-all duration-300 ${
                isActive('/quem-somos') 
                  ? 'w-full' 
                  : 'w-0 group-hover:w-full'
              }`}></span>
            </Link>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 transition-colors ${getMobileButtonClasses()}`}
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-gray-800 shadow-lg">
            <nav className="flex flex-col py-4">
              <Link 
                to="/" 
                className={`${getTextClasses(isActive('/'))} mx-4 rounded-md`}
                onClick={closeMobileMenu}
              >
                <Home className="w-4 h-4" />
                <span>Início</span>
              </Link>
              <Link 
                to="/busca" 
                className={`${getTextClasses(isActive('/busca'))} mx-4 rounded-md`}
                onClick={closeMobileMenu}
              >
                <Search className="w-4 h-4" />
                <span>Buscar</span>
              </Link>
              <Link 
                to="/quem-somos" 
                className={`${getTextClasses(isActive('/quem-somos'))} mx-4 rounded-md`}
                onClick={closeMobileMenu}
              >
                <Users className="w-4 h-4" />
                <span>Quem Somos</span>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;